import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { AuthStore, DashboardUserType } from '@store';

import { filter, map } from 'rxjs/operators';

export const oldInstallationListGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);

  return authStore.dashboardUserType$.pipe(
    filter((val) => val !== undefined),
    map((dashboardUserType) => {
      if (dashboardUserType === DashboardUserType.Maintainer) {
        return false;
      } else {
        return true;
      }
    })
  );
};
